'use strict';

var _ = require('lodash');
var ProfileChartUrdSettingProviderService = function ProfileChartUrdSettingProviderService(userPreferencesService, constants) {
  var POST_DEPARTURE_SUFFIX = '-post-departure';
  var screenToWorkflow = {
    'FLIGHT_SCREEN': 'flightAnalysis',
    'MARKET_SCREEN': 'marketAnalysis'
  };
  function getWorkflow(screen, mode) {
    var workflow = screenToWorkflow[screen];
    return _.includes(mode, POST_DEPARTURE_SUFFIX) ? workflow + 'PostDeparture' : workflow;
  }
  var urdCurvesDisabledFilter = [constants.MIN, constants.AVG, constants.MAX].map(_.lowerCase);
  function getUrdFilter(screen, mode) {
    var workflow = getWorkflow(screen, mode);
    return userPreferencesService.getUserOrDefaultSettingComponent('showUrdProfileCurves', workflow) ? [] : urdCurvesDisabledFilter;
  }
  return {
    getUrdFilter: getUrdFilter
  };
};
ProfileChartUrdSettingProviderService.$inject = ['UserPreferencesService', 'ProfileChartConstants'];
module.exports = ProfileChartUrdSettingProviderService;